import { staticComponentValueConverter } from '../StaticComponentValues';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useMemo } from 'react';

function ButtonBase({ item, imageWidth }) {
  const customization = staticComponentValueConverter(item?.customization);
  const iconFilter = useMemo(() => HexToHueConverter(customization?.iconColor), [customization?.iconColor]);

  return (
    <div
      style={{
        padding: `${customization?.containerPadding}`,
        backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
        backgroundImage:
          customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }}
    >
      {item?.data?.text ? (
        <div
          className=" border-1"
          style={{
            width: `${imageWidth}%`,
            backgroundColor: customization?.innerBackgroundColor,
            color: customization?.textColor,
            borderRadius: customization?.borderRadius,
            borderColor: customization?.borderColor,
            display: 'flex',
            justifyContent: !customization?.isIcon ? 'center' : 'space-between',
            alignItems: 'center',
            padding: customization?.padding,
            fontSize: customization?.textSize,
            fontWeight: customization?.textWeight,
            marginRight:
              customization?.buttonAlignment === 'left' || customization?.buttonAlignment === 'center'
                ? 'auto'
                : 'unset',
            marginLeft:
              customization?.buttonAlignment === 'right' || customization?.buttonAlignment === 'center'
                ? 'auto'
                : 'unset',
          }}
        >
          {!customization?.isIcon ? (
            <div className="w-full break-words " style={{ textAlign: customization?.textAlignment }}>
              {item?.data?.text}
            </div>
          ) : (
            <>
              <div
                className="break-words"
                style={{
                  flex: 1,
                  textAlign: customization?.textAlignment,
                  maxWidth: `calc(100% - ${customization?.iconWidth})`,
                }}
              >
                {item?.data?.text}
              </div>
              <div>
                <div
                  style={{
                    backgroundColor: customization?.iconBackgroundColor,
                    color: customization?.iconColor,
                    borderRadius: customization?.iconBorderRadius,
                  }}
                >
                  <img
                    src={customization?.icon}
                    style={{ width: customization?.iconWidth, filter: iconFilter }}
                    alt=""
                  />
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <img src={item?.placeholderImage} className={` w-full `} />
      )}
    </div>
  );
}

export default ButtonBase;
